import { t } from '@/locale/index.js'
import { applyColumnLabels, applyOptionLabels, applySearchLabels } from '@/utils/listPageI18n.js'

const SCORE_RULE_COLUMNS = {
  level_name: 'scoreRule.levelName',
  required_points: 'scoreRule.requiredPoints',
  status: 'field.status',
  operation: 'table.operation',
}

const SCORE_REWARD_COLUMNS = {
  reward_name: 'scoreReward.itemName',
  required_points: 'scoreRule.requiredPoints',
  status: 'field.status',
  operation: 'table.operation',
}

const SCORE_REDEMPTION_COLUMNS = {
  real_name: 'scoreRedemption.user',
  reward_name: 'scoreReward.itemName',
  mobile: 'field.mobile',
  redeemed_points: 'scoreRedemption.consumedPoints',
  redemption_time: 'scoreRedemption.redemptionTime',
}

const SCORE_LOTTERY_RECORD_COLUMNS = {
  real_name: 'scoreLotteryRecord.userName',
  username: 'scoreLotteryRecord.account',
  level_name: 'scoreLottery.colLevel',
  prize_name: 'scoreLottery.colPrizeName',
  points_tier: 'scoreLotteryRecord.pointsTier',
  is_redeemed: 'scoreLotteryRecord.redeemStatus',
  created_at: 'scoreLotteryRecord.drawTime',
}

export function applyScoreRuleListLabels({ columns, statusOptions }) {
  applyColumnLabels(columns, SCORE_RULE_COLUMNS)
  applyOptionLabels(statusOptions, {
    1: 'status.enabled',
    0: 'status.disabled',
  })
}

export function applyScoreRewardListLabels({ columns, statusOptions }) {
  applyColumnLabels(columns, SCORE_REWARD_COLUMNS)
  applyOptionLabels(statusOptions, {
    1: 'status.enabled',
    0: 'status.disabled',
  })
}

export function applyScoreRedemptionListLabels({ searchData, columns }) {
  applySearchLabels(searchData, {
    keywords: { labelKey: 'scoreRedemption.nameKeyword' },
  })
  applyColumnLabels(columns, SCORE_REDEMPTION_COLUMNS)
}

export function applyScoreLotteryRecordLabels({ searchData, columns }) {
  applySearchLabels(searchData, {
    keywords: {
      labelKey: 'field.keywords',
      placeholderKey: 'scoreLotteryRecord.keywordPlaceholder',
    },
  })
  applyColumnLabels(columns, SCORE_LOTTERY_RECORD_COLUMNS)
}

export function applyScoreRuleFormRules(rules) {
  if (rules.level_name?.[0]) rules.level_name[0].message = t('scoreRule.needLevelName')
  if (rules.required_points?.[0]) rules.required_points[0].message = t('scoreRule.needRequiredPoints')
  if (rules.status?.[0]) rules.status[0].message = t('taskSpecial.needStatus')
}

export function applyScoreRewardFormRules(rules) {
  if (rules.reward_name?.[0]) rules.reward_name[0].message = t('scoreReward.needItemName')
  if (rules.description?.[0]) rules.description[0].message = t('scoreReward.needItemDesc')
  if (rules.required_points?.[0]) rules.required_points[0].message = t('scoreRule.needRequiredPoints')
  if (rules.status?.[0]) rules.status[0].message = t('taskSpecial.needStatus')
}

export function applyScoreRedemptionFormRules(rules) {
  if (rules.user_id?.[0]) rules.user_id[0].message = t('scoreRedemption.needUser')
  if (rules.reward_id?.[0]) rules.reward_id[0].message = t('scoreRedemption.needReward')
}

export function applyScoreLotteryPrizeRules(rules) {
  if (rules.level?.[0]) rules.level[0].message = t('scoreLottery.needLevel')
  if (rules.prize_name?.[0]) rules.prize_name[0].message = t('scoreLottery.needPrizeName')
  if (rules.probability?.[0]) rules.probability[0].message = t('scoreLottery.needProbability')
}

export function applyScoreRemindRules(rules) {
  if (rules.content?.[0]) rules.content[0].message = t('scoreRemind.needContent')
}

export { t }
